module.exports = __webpack_public_path__ + "static/media/ceilings_material_60y_n.ce770d6e.csv";